import React, { useState, useContext, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";
import { setPasoMultitabSinTurno } from "../../../context/Actions/multitabSinTurno/multitabSinTurno";
import "./MultitabAtencionSinTurno.css";

const MultitabAtencionSinTurno = ({ tabs, width, desactivar }) => {
  const { multitabSinTurnoState, multitabSinTurnoDispatch } = useContext(PortalContext);
  const [numActivo, setNumActivo] = useState(0);

  const activarPestania = (num) => {
      setPasoMultitabSinTurno(num)(multitabSinTurnoDispatch)
  };

  useEffect(() => {
    if (multitabSinTurnoState.multitabSinTurno === undefined) setNumActivo(0);
    else setNumActivo(multitabSinTurnoState.multitabSinTurno.paso);
  }, [multitabSinTurnoState]);
  

  const divStyle = {
    width: width,
  };
  return (
    <React.Fragment>
      <div
        className="contenedor-multitab-MultitabAtencionSinTurno bgc-grey95"
        style={divStyle}
      >
        {Array.isArray(tabs) &&
          tabs.length > 0 &&
          tabs.map((item, index) => {
            return (
              <div
                className={`pestania  ${
                  numActivo === index ? "bgc-latex10" : "usarHover"
                }`}
                onClick={() => activarPestania(index, desactivar, item)}
                key={index}
              >
                {numActivo === index && (
                  <div className="flecha bgc-latex10"></div>
                )}
                <div className="multitab-MultitabAtencionSinTurno-titulo">
                  <h2
                    className={`m-0 rb18m textCenter ${
                      numActivo === index ? "c-white" : "usarHover2"
                    }`}
                  >
                    {item.nombre}
                  </h2>
                </div>
              </div>
            );
          })}
      </div>
      {Array.isArray(tabs) &&
        tabs.length > 0 &&
        tabs.map((item, index) => {
          return (
            item.carpeta !== "" &&
            item.componente !== "" &&
            numActivo === index &&
            React.createElement(
              require(`../../Perfil/CardCentros/` +
                item.carpeta +
                "/" +
                item.componente).default,
              item.params
            )
          );
        })}
    </React.Fragment>
  );
};
export default MultitabAtencionSinTurno;
